// The body of an AppDialog scrolls inside the dialog, so a long list never pushes the footer and its
// buttons out of the screen (MUI's DialogContent did this; AppDialogBody is a plain box).
export const dialogBodySx = { overflowY: 'auto', minHeight: 0 }

export default dialogBodySx
